import { RegisterRequestedFieldType } from "../requested-field-types"
import { RequestedFieldEditor, RequestedFieldInput, RequestedFieldValue } from "../share-link-fields-slot-definitions"
import { CurrencyFieldInput } from "../currency-field-input"
import { CurrencyFieldValue } from "../currency-field-value"
import { CurrencyCodeEditor } from "../currency-code-editor"

/**
 * Self-registering plugin for the "currency" requested-field type. Registers the type's metadata,
 * plugs its recipient input + read-only value renderers, and the builder per-type extra (the currency
 * code selector shown under the row in the requested-information editor).
 */
RegisterRequestedFieldType.handleOnce(({ types }) => types.push({ value: "currency", label: "Currency", priority: 40 }))

RequestedFieldInput("currency").plug(<CurrencyFieldInput />)
RequestedFieldValue("currency").plug(<CurrencyFieldValue />)
RequestedFieldEditor("currency").plug(<CurrencyCodeEditor />)
